'use strict';


async function refreshCartDrawer() {
    const res = await fetch(`${window.Shopify.routes.root}cart?sections=cart-drawer,cart-icon-bubble`);
    const sections = await res.json();

    // Вставляем новый Drawer полностью
    const drawerContainer = document.querySelector('cart-drawer');
    if (drawerContainer) {
        const newHTML = new DOMParser()
            .parseFromString(sections['cart-drawer'], 'text/html')
            .querySelector('cart-drawer');

        drawerContainer.replaceWith(newHTML);

        // Drawer перерегистрируется автоматически (Shopify custom element)
    }

    // Обновляем bubble
    const bubble = document.querySelector('#cart-icon-bubble');
    if (bubble) {
        const newBubble = new DOMParser()
            .parseFromString(sections['cart-icon-bubble'], 'text/html')
            .querySelector('#cart-icon-bubble');
        bubble.replaceWith(newBubble);
    }

    // Открываем новый Drawer
    setTimeout(() => {
        const newDrawer = document.querySelector('cart-drawer');
        newDrawer?.open();
    }, 100);
}


document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.ft-add-to-cart-btn');
    if (!buttons.length) return;

    buttons.forEach(button => {
        button.addEventListener('click', async () => {
            const variantId = Number(button.dataset.variantId);
            if (!variantId) return;

            button.classList.add('loading');
            button.disabled = true;

            try {
                // 1️⃣ Добавляем товар
                const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({ id: variantId, quantity: 1 })
                });

                if (!res.ok) throw new Error(await res.text());
                const addedItem = await res.json();

                // 2️⃣ Запрашиваем обновлённые секции
                const sectionsRes = await fetch(`${window.Shopify.routes.root}cart?sections=cart-drawer,cart-icon-bubble`);
                const sections = await sectionsRes.json();

                // 3️⃣ Используем метод темы, как делает стандартный product-form
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                    cartDrawer.renderContents({
                        id: addedItem.id,
                        sections
                    });
                } else {
                    console.warn('⚠️ cart-drawer не найден, fallback -> просто откроем его');
                    document.querySelector('cart-drawer')?.open?.();
                }

            } catch (err) {
                console.error('🚨 Ошибка добавления в корзину:', err);
            } finally {
                button.classList.remove('loading');
                button.disabled = false;
            }
        });
    });
});

// Фикс бага trapFocus при пустой корзине
(function () {
    const originalOpen = CartDrawer.prototype.open;
    CartDrawer.prototype.open = function (triggeredBy) {
        try {
            originalOpen.call(this, triggeredBy);
        } catch (err) {
            console.warn('⚠️ CartDrawer open() skipped trapFocus error:', err.message);
        }
    };
})();


// Timer - Countdown
document.addEventListener('DOMContentLoaded', () => {
    const timers = document.querySelectorAll('.ft-countdown');

    timers.forEach(timer => {
        const endTs = parseInt(timer.dataset.endTs, 10) * 1000;
        const endDate = new Date(endTs);

        const daysGroup = timer.querySelector('.ft-countdown__days-group');

        const d1 = timer.querySelector('.d1');
        const d2 = timer.querySelector('.d2');

        const h1 = timer.querySelector('.h1');
        const h2 = timer.querySelector('.h2');

        const m1 = timer.querySelector('.m1');
        const m2 = timer.querySelector('.m2');

        const s1 = timer.querySelector('.s1');
        const s2 = timer.querySelector('.s2');

        function update() {
            const now = new Date();
            const diff = endDate - now;

            if (diff <= 0) {
                [d1, d2, h1, h2, m1, m2, s1, s2].forEach(el => el.textContent = "0");
                return;
            }

            const totalSeconds = Math.floor(diff / 1000);

            const days = Math.floor(totalSeconds / 86400);
            const hours = Math.floor((totalSeconds % 86400) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            // SHOW DAYS ONLY IF > 0
            if (days > 0) {
                //daysGroup.style.display = "grid";
                const ds = String(days).padStart(2, '0');
                d1.textContent = ds[0];
                d2.textContent = ds[1];
            }

            const hs = String(hours).padStart(2, '0');
            const ms = String(minutes).padStart(2, '0');
            const ss = String(seconds).padStart(2, '0');

            h1.textContent = hs[0];
            h2.textContent = hs[1];

            m1.textContent = ms[0];
            m2.textContent = ms[1];

            s1.textContent = ss[0];
            s2.textContent = ss[1];
        }

        update();
        setInterval(update, 1000);
    });
});







document.addEventListener('DOMContentLoaded', () => {
    // Находим форму Shopify
    const productForm = document.querySelector('.product form[action*="/cart/add"]');
    const targetEl = document.querySelector('[data-product-variant-id]');
    if (!productForm || !targetEl) return;

    const variantInput = productForm.querySelector('input[name="id"]');
    if (!variantInput) {
        console.warn('⚠️ Не найден input[name="id"]');
        return;
    }

    // Функция обновления атрибута
    const updateVariantAttr = () => {
        const variantId = variantInput.value;
        if (!variantId) return;
        targetEl.setAttribute('data-product-variant-id', variantId);
        console.log('🟢 Обновлён variant ID:', variantId);
    };

    // Первичная установка
    updateVariantAttr();

    // Отслеживаем изменения value у input[name="id"]
    const observer = new MutationObserver(() => {
        updateVariantAttr();
    });

    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

    // Также можно слушать смену опций (на случай кастомных форм)
    productForm.addEventListener('change', () => {
        setTimeout(updateVariantAttr, 50);
    });
});



